import { Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT_EMAIL, INSTAGRAM_HANDLE, INSTAGRAM_URL, NAV } from "../data/content";
import { WhatsAppButton } from "./WhatsApp";
import { scrollToHash } from "../lib/smooth";

export const Footer = () => (
  <footer className="border-t border-[#2E2B27] bg-[#161513] text-[#FAF8F5]" data-testid="site-footer">
    <div className="mx-auto max-w-[1440px] px-5 py-14 sm:px-10">
      <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
        <Logo light />
        <nav className="flex flex-wrap gap-x-8 gap-y-3">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} onClick={(e) => { e.preventDefault(); scrollToHash(n.href); }} className="link-underline text-base text-[#CFC8BD] hover:text-white" data-testid={`footer-link-${n.label.toLowerCase()}`}>{n.label}</a>
          ))}
        </nav>
        <div className="space-y-2 text-base">
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[#CFC8BD] hover:text-white" data-testid="footer-instagram-link">
            <Instagram className="h-4 w-4" /> @{INSTAGRAM_HANDLE}
          </a>
          <a href={`mailto:${CONTACT_EMAIL}`} className="block text-[#CFC8BD] hover:text-white" data-testid="footer-email">{CONTACT_EMAIL}</a>
          <WhatsAppButton testId="footer-whatsapp-link" className="text-[#CFC8BD] hover:text-white">+1 (347) 703-0817</WhatsAppButton>
        </div>
      </div>
      <p className="mt-14 font-display text-[18vw] leading-none tracking-tight text-[#2A2724] lg:text-[13vw]" aria-hidden="true">Ulyana Shmidt</p>
      <div className="mt-6 flex flex-col justify-between gap-2 text-sm text-[#A39C92] sm:flex-row">
        <span>© {new Date().getFullYear()} Ulyana Shmidt. Personal Stylist, New York.</span>
        <span>Pricing on request</span>
      </div>
    </div>
  </footer>
);
